import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=3d22801c&scoped=true"
import script from "./scope.vue?vue&type=script&lang=js"
export * from "./scope.vue?vue&type=script&lang=js"
import style0 from "./scope.vue?vue&type=style&index=0&id=3d22801c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22801c",
  null
  
)

export default component.exports